import { ReactNode } from 'react';
import { useInViewOnce } from 'frontastic';

type ViewOnceProps = {
  children: ReactNode;
  onView?: () => void;
};

const ViewOnce = ({ children, onView }: ViewOnceProps) => {
  const { ref } = useInViewOnce(onView);

  return <div ref={ref}>{children}</div>;
};

export { ViewOnce };
